// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"5cbe0cea","371":"976aae30","475":"8f869eb6","515":"5cb11047","538":"8261a178","631":"3ecfc7cf","679":"e48b23dd","680":"31f1f90b","997":"45d0c492"}[chunkId] + ".chunk.css";
};